import * as actionTypes from "../actions/actionTypes";

const initialState = {
  // token: null,
  // userId: null,
  // isAuth: false,
  posts: [],
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_POSTS:
      // console.log("set posts reducer", action);
      const { payload } = action;
      return {
        ...state,
        posts: payload,
      };
    default:
      return state;
  }
};

export default reducer;
